import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import '../../../types/product.js';
import { isContactLensVariant } from '../../../types/typeguards.js';
import { useBrandLink } from './hooks/use-brand-link.js';
import { ProductDetailTitle } from './ProductDetailTitle.js';

const ProductDetailTitleContainer = ()=>{
    const { activeVariant , product: { brandName  } ,  } = useProductData();
    const isContactLens = isContactLensVariant(activeVariant);
    const brandLink = useBrandLink();
    const { isPdpModelCodeDisabled  } = useFeatureToggles();
    let title;
    if (isPdpModelCodeDisabled) {
        var _brandModelCode;
        title = activeVariant.displayName.replace('brandModelCode' in activeVariant ? (_brandModelCode = activeVariant.brandModelCode) !== null && _brandModelCode !== void 0 ? _brandModelCode : '' : '', '').replace(/ {2,}/g, ' ').trim();
    } else {
        title = activeVariant.displayName;
    }
    let subtitle = brandName;
    if (isContactLens && activeVariant.replacementFrequency) {
        subtitle = activeVariant.replacementFrequency;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailTitle, {
        title: title,
        subtitle: subtitle,
        href: brandLink,
        sku: activeVariant.sku
    });
};

export { ProductDetailTitleContainer };
//# sourceMappingURL=ProductDetailTitleContainer.js.map
